import React from "react";
import GridHeader from "./Grid/GridHeader";
import { Alert, Container } from "reactstrap";
import GridBody from "./Grid/GridBody";
import withRouter from "../../../components/Common/withRouter";
import { DF_MO0007Context } from "./context";

function DF_MO0007(props) {
  document.title = "Defender | Comparação de versões";
  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);

  if (!parseParams.get("ID_Arquivo")) {
    return (
      <Alert color="danger">
        Não é possível acessar essa transação sem parametros
      </Alert>
    );
  }

  return (
    <DF_MO0007Context.Provider
      value={{
        parseParams,
      }}
    >
      <div className="page-content">
        <Container fluid={true} className="dataTable-custom-primary">
          <GridHeader />
          <GridBody />
        </Container>
      </div>
    </DF_MO0007Context.Provider>
  );
}

export default withRouter(DF_MO0007);
